import React from 'react';
import styles from './ContactCard.module.css';

const Avatar = (props) => {
  return (
    <img className={styles.circle_img} src={props.image} alt="avatar_img" />
  );
};

export default Avatar;
